import { render, staticRenderFns } from "./viewPatientConsultation.vue?vue&type=template&id=2f9d0695&"
import script from "./viewPatientConsultation.vue?vue&type=script&lang=js&"
export * from "./viewPatientConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports